module.exports = __webpack_public_path__ + "1d86790a12f81cc60ab837c979bab63d.ttf";